import { Stack, Typography, Box } from '@mui/material'
import { useContext, useEffect, useState } from 'react'
import VendorListTable from './VendorMangTable';
import AddIcon from '@mui/icons-material/Add';
import AddEditVendorModal from './AddNewVendorModal';
import { endpoints } from '../../api/endpoints';
import { useCrudForm } from '../../api/useCrudForm';
import { AddLookUpBtn } from '../../components/styledComponent/Button';
import { AppContext } from '../../contexts/AppContext';

const VendorManagement = () => {

  const [open, setOpen] = useState(false)
  const [selectedItem, setSelectedItem] = useState<any | null>()
  const [vendorList, setVendorList] = useState<any | null>()
  const [isView, setIsView] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false);
  const [skip, setSkip] = useState(0)
  const [count, setCount] = useState<any>(0);
  const [take, setTake] = useState(10)

  const { get } = useCrudForm();
  const { user } = useContext(AppContext)

  const refetchData = () => {
    get({
      endpoints: `${endpoints.lockerVendor.get}?skip=${skip * take}&take=${take}`,
      onSuccess: (data: any) => {
        setLoading(false)
        setVendorList(data.data.list)
        setCount(data.data.count)
      },
      onError: (error: any) => {
        setLoading(false)

        console.log(error)
      }
    })
  }

  useEffect(() => {
    setLoading(true)
    refetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip, take])

  return (
    <>
      <Typography variant="h5" component="h5" mb={1} fontWeight={600}>
        Vendor Management
      </Typography>
      <Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
        {
          user && (user?.role)?.toLowerCase() === 'admin' ?
            <Stack direction="row" mb={3} spacing={2} sx={{ justifyContent: "end", alignItems: "center" }}>
              <AddLookUpBtn onClick={() => setOpen(true)}>
                <AddIcon />
                <Typography>New Vendor</Typography>
              </AddLookUpBtn>
            </Stack>
            : null
        }
        <VendorListTable refetchData={refetchData} loading={loading} skip={skip} take={take} setTake={setTake} setSkip={setSkip} count={count} setOpen={setOpen} setSelectedItem={setSelectedItem} rows={vendorList} setIsView={setIsView} />
      </Box>
      <AddEditVendorModal refetchData={refetchData} setIsView={setIsView} isView={isView} open={open} setOpen={setOpen} selectedItem={selectedItem} setSelectedItem={setSelectedItem} />
    </>
  )
}

export default VendorManagement
